module.exports = __webpack_public_path__ + "img/pizza-1.71c74bc1.jpg";